export const nodes = [
  {
    id: 1,
    nodeType: "root",
    firstName: "Jon",
    lastName: "Snow",
    gender: "male",
    profilePicture: "/assets/icons/you.png",
    edit: "/assets/icons/edit.png",
    dateOfBirth: "1995-06-02",
    address: "Pakistan",
    addNew: "/assets/icons/plus.png",
    relationship: "root",
  },
];
